export const en = {
    advertisement: 'Advertising',
    'agency-client-help-link': 'Yandex customer service department',
    'common-help-link': 'Customer service department',
    'self-agency-help-link': 'Department for working with ad agencies'
};
